var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"lightwidget-widget",staticStyle:{"width":"100%","border":"0","overflow":"hidden"},attrs:{"src":"https://cdn.lightwidget.com/widgets/3e4241f3b5c25eb89fd9328061d9c463.html","scrolling":"no","allowtransparency":"true"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b588cc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InstagramDisplay.vue
// module id = null
// module chunks = 